var _enable_super_gross_mode_that_will_cause_bad_things = false;
var _enable_deoptimized_subscriber_creation = false;
export var config = {
    quietBadConfig: false,
    Promise: undefined,
    set useDeprecatedSynchronousErrorHandling(value) {
        if (!this.quietBadConfig) {
            if (value) {
                var error = new Error();
                console.warn('DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n' + error.stack);
            }
            else if (_enable_super_gross_mode_that_will_cause_bad_things) {
                console.log('RxJS: Back to a better error behavior. Thank you. <3');
            }
        }
        _enable_super_gross_mode_that_will_cause_bad_things = value;
    },
    get useDeprecatedSynchronousErrorHandling() {
        return _enable_super_gross_mode_that_will_cause_bad_things;
    },
    set useDeprecatedNextContext(value) {
        if (!this.quietBadConfig) {
            if (value) {
                var error = new Error();
                console.warn('DEPRECATED! RxJS was set to use deprecated next context. This will result in deoptimizations when creating any new subscription. \n' +
                    error.stack);
            }
            else if (_enable_deoptimized_subscriber_creation) {
                console.log('RxJS: back to more optimized subscription creation. Thank you. <3');
            }
        }
        _enable_deoptimized_subscriber_creation = value;
    },
    get useDeprecatedNextContext() {
        return _enable_deoptimized_subscriber_creation;
    },
};
//# sourceMappingURL=config.js.map